/**
 * https://www.tapd.cn/69107998/prong/stories/view/1169107998001087231
 * 中东国家 不展示符号(如￥$)
 */
export const middleEast = ["SAR", "AED", "OMR", "BHD", "KWD", "QAR"];

const transformArrayByFilling = (items: string[], symbol: string) => {
	return items.reduce((result, item: string) => {
		return {
			...result,
			[item]: symbol,
		};
	}, {});
};

const priceGraph = {
	...transformArrayByFilling(
		["USD", "CAD", "CLP", "NZD", "ARS", "COP", "AUD", "HKD", "MXN"],
		"$",
	),
	...transformArrayByFilling(["CNY", "JPY"], "￥"),
	...transformArrayByFilling(["GBP", "EGP"], "£"),
	...transformArrayByFilling(["NOK", "DKK"], "kr."),
	EUR: "€",
	RUB: "p.",
	BRL: "R$",
	SEK: "Kr.",
	KRW: "₩",
	ILS: "₪",
	SGD: "S$",
	INR: "Rs",
	CZK: "Kč",
	PLN: "zł",
	JOD: "JD",
	THB: "฿",
	ZAR: "R",
	IDR: "Rp",
};
export const getSymbolByCurreny = (currency: string) => {
	return priceGraph[currency] || "";
};

const priceWithDisplay = {
	"1": false,
	"2": [
		"IDR", // 印尼 卢比
		"KZT", // 哈萨克斯坦
		"PLN", // 波兰 兹罗提
		"RON", // 罗马尼亚 新蕾
		"BRL", // 巴西 雷亚尔
		"DKK", // 丹麦 可郎
		"HRK", // 克罗地亚 库纳
		"BGN", // 保加利亚 利瓦
		"SGD", // 新加坡 元
		"HUF", // 匈牙利 福林
		"MXN", // 墨西哥 比索
		"EGP", // 埃及 镑
		"TRY", // 土耳其 里拉
		"ZAR", // 南非 兰特
		"CLP", // 智利 比索
		"KRW", // 韩元
		"COP", // 哥伦比亚 比索
	],
	"20": ["IDR", "KZT"],
	"3": true,
};
interface GetPriceDisplayProps {
	columnNum: number;
	isRollable: boolean;
	currency: string;
}
export const getPriceDisplay = ({ isRollable, columnNum, currency }: GetPriceDisplayProps) => {
	if (!columnNum) {
		return false;
	}
	const nextKey = isRollable ? "20" : columnNum;
	const priceDisplay = priceWithDisplay[nextKey];
	if (typeof priceDisplay === "boolean") {
		return priceDisplay;
	}

	return Object.values(priceDisplay).includes(currency);
};
